export const ROOT_NODE = 'total'

/** Find the visible group path for a group or product node. */
export function findNodeChain(groups, node, ancestors = []) {
  for (const group of groups) {
    const chain = group.kind === 'root' ? ancestors : [...ancestors, group]
    if (group.code === node || (group.pids ?? []).some((p) => `pid:${p.pid}` === node)) {
      return chain
    }
    const child = findNodeChain(group.children ?? [], node, chain)
    if (child !== null) return child
  }
  return null
}

/** A removed or inaccessible node must use the same root shown by the picker. */
export const availableNode = (groups, node) =>
  node === ROOT_NODE || findNodeChain(groups, node) !== null ? node : ROOT_NODE
